import React from 'react';

/**
 * A flat, realistic hotel-room interior (bed, headboard, pillows, curtained window, lamp).
 * Used as a fallback "photo" for room-type cards that have no uploaded image, so rooms show a
 * realistic room instead of a generic icon. Fills its container.
 */
const RoomIllustration: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 200 120"
    preserveAspectRatio="xMidYMid slice"
    role="img"
    aria-label="Room"
  >
    {/* wall + floor */}
    <rect x="0" y="0" width="200" height="86" fill="#f4f1ea" />
    <rect x="0" y="84" width="200" height="36" fill="#d8c3a3" />
    <rect x="0" y="84" width="200" height="4" fill="#c6ac86" />
    {/* framed art */}
    <rect x="20" y="14" width="26" height="20" rx="1.5" fill="#e9eef4" stroke="#b9c4d2" strokeWidth="2" />
    <path d="M24 30 L31 22 L36 27 L40 22 L42 30 Z" fill="#9db8d6" />
    {/* window with curtains */}
    <rect x="118" y="10" width="9" height="52" rx="3" fill="#cbd5e1" />
    <rect x="171" y="10" width="9" height="52" rx="3" fill="#cbd5e1" />
    <rect x="126" y="14" width="46" height="42" rx="2" fill="#bcd9f0" stroke="#9aa7b6" strokeWidth="2" />
    <line x1="149" y1="14" x2="149" y2="56" stroke="#eef6fd" strokeWidth="2" />
    <line x1="126" y1="35" x2="172" y2="35" stroke="#eef6fd" strokeWidth="2" />
    {/* nightstand + lamp */}
    <rect x="60" y="60" width="22" height="24" fill="#a98d6f" />
    <rect x="70" y="44" width="2.5" height="16" fill="#8a7157" />
    <path d="M63 44 L79 44 L75 33 L67 33 Z" fill="#f4d58d" stroke="#e0b95e" strokeWidth="1.2" />
    {/* bed: headboard, pillows, mattress, duvet */}
    <rect x="86" y="40" width="104" height="24" rx="5" fill="#a98d6f" />
    <rect x="82" y="62" width="112" height="34" rx="5" fill="#eef1f5" stroke="#dde3ea" strokeWidth="1.5" />
    <rect x="94" y="55" width="36" height="17" rx="7" fill="#ffffff" stroke="#dbe2ea" strokeWidth="1.5" />
    <rect x="136" y="55" width="36" height="17" rx="7" fill="#ffffff" stroke="#dbe2ea" strokeWidth="1.5" />
    <rect x="82" y="80" width="112" height="16" fill="#aec3dd" />
    <rect x="82" y="80" width="112" height="4" fill="#9db4d0" />
  </svg>
);

export default RoomIllustration;
